module.exports = __webpack_public_path__ + "static/media/zuikaku.4f285d74.png";